/**
 * Shared cookie-session refresh helper.
 * Calls backend /api/auth/refresh using HttpOnly refresh cookie.
 */
import { CSRF_HEADER_NAME, getCsrfToken } from './csrf';

let inFlightRefresh: Promise<boolean> | null = null;

async function doRefresh(): Promise<boolean> {
  try {
    const apiBase = process.env.REACT_APP_API_URL || 'https://vineblock.onrender.com';
    const csrfToken = getCsrfToken();
    const response = await fetch(`${apiBase}/api/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers: csrfToken ? { [CSRF_HEADER_NAME]: csrfToken } : undefined,
    });
    return response.ok;
  } catch {
    return false;
  }
}

export async function refreshAuthToken(): Promise<boolean> {
  if (inFlightRefresh) {
    return inFlightRefresh;
  }
  inFlightRefresh = doRefresh();
  try {
    return await inFlightRefresh;
  } finally {
    inFlightRefresh = null;
  }
}
